<template>
    <form-header></form-header>
    <router-view></router-view>
    <form-footer></form-footer>
    <icons></icons>
</template>
<script>
// import Preloader from "@/components/Preloader";
import FormHeader from "@/components/FormHeader";
import FormFooter from "@/components/FormFooter";
import Icons from "@/components/Icons";
export default {
    components: {
    // Preloader,
    FormHeader,
    FormFooter,
    Icons
  }
}
</script>